<template>
  <TurnsForm :typeEndPoint="'adminTurnsForm'" :dataParams="{}"/>
</template>
<script>
import TurnsForm from '@/components/modules/admin/turns/form'
export default {
  name: 'TurnsFormCreate',
  components: {
    TurnsForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/turns/create.vue